import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { useAuthStore } from "../store";

type Category = { id: string; name: string };
type InventoryItem = {
  id: string;
  name: string;
  categoryId: string | null;
  category: string;
  quantity: number;
  unitCost: number;
};

const formatCurrency = (cents: number) => new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }).format(cents / 100);

export function InventoryPage() {
  const token = useAuthStore((state) => state.token);
  const [search, setSearch] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const query = useMemo(() => {
    const params = new URLSearchParams();
    if (search.trim()) params.set("search", search.trim());
    if (categoryId) params.set("categoryId", categoryId);
    const value = params.toString();
    return value ? `?${value}` : "";
  }, [search, categoryId]);
  const inventory = useQuery({ queryKey: ["inventory", query], queryFn: () => api<InventoryItem[]>(`/api/v1/inventory${query}`, {}, token || undefined) });
  const categories = useQuery({ queryKey: ["categories"], queryFn: () => api<Category[]>("/api/v1/categories", {}, token || undefined) });
  const clearFilters = () => { setSearch(""); setCategoryId(""); };

  return <section><div className="page-heading"><div><p className="eyebrow">04 / STOCK</p><h2>Inventory</h2><p className="subhead">Search product quantities across catalog groups and track what is available on hand.</p></div><span className="tag">{inventory.data?.length || 0} RECORDS</span></div>
    <div className="panel form-panel"><div className="table-head"><h3>Find inventory</h3><button className="ghost-button" type="button" onClick={clearFilters}>Clear filters</button></div><form className="crud-form" onSubmit={(event) => event.preventDefault()}><label>Search<input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Product name or category" /></label><label>Category<select value={categoryId} onChange={(event) => setCategoryId(event.target.value)}><option value="">All categories</option>{categories.data?.map((category) => <option key={category.id} value={category.id}>{category.name}</option>)}</select></label></form></div>
    {inventory.isError && <div className="notice">{(inventory.error as Error).message}</div>}
    {categories.isError && <div className="notice">{(categories.error as Error).message}</div>}
    <div className="panel table-panel"><div className="table-head"><h3>Inventory list</h3></div>{inventory.isLoading ? <div className="module-empty"><p>Loading inventory…</p></div> : inventory.data?.length ? <div className="record-list">{inventory.data.map((item) => <div className="record-row" key={item.id}><div><strong>{item.name}</strong><span>{item.category}</span></div><div><strong>Available stock: {item.quantity}</strong><span>{formatCurrency(item.unitCost)}</span></div></div>)}</div> : <div className="module-empty"><p>No inventory matches these filters.</p><button className="ghost-button" onClick={clearFilters}>Clear filters</button></div>}</div>
  </section>;
}
